import { useEffect } from "react";

const getIsTablet = () => {
    const hasTouch = window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;
    const width = window.screen.width;
    const height = window.screen.height;
    const smallestSide = Math.min(width, height);
    return hasTouch && smallestSide >= 600 && smallestSide <= 1280;
};

export default function useTabletViewport() {
    useEffect(() => {
        const meta = document.getElementById("viewport-meta");
        if (!meta) return;
        const setViewport = () => {
            const isTablet = getIsTablet();
            const newContent = isTablet
                ? "width=device-width, initial-scale=0.8, maximum-scale=0.8, user-scalable=no"
                : "width=device-width, initial-scale=1";
            if (meta.getAttribute("content") !== newContent) {
                meta.setAttribute("content", newContent);
            }
        };
        setViewport();
        const handleOrientationChange = () => { setTimeout(setViewport, 300) };
        window.addEventListener("orientationchange", handleOrientationChange);
        return () => {
            window.removeEventListener("orientationchange", handleOrientationChange);
        };
    }, []);
}